/* eslint react-hooks/exhaustive-deps: "warn" */

import { SectionShell } from '../../atoms/SectionShell/SectionShell';
import type { DefinitionSectionProps } from './DefinitionSection.types';

export const DefinitionSection = ({ topic, className }: DefinitionSectionProps) => {
  if (!topic.importance?.trim()) {
    return null;
  }

  const paragraphs = topic.importance.split('\n\n');

  return (
    <SectionShell id="definition" title={`${topic.name}: why it matters`} className={className}>
      {paragraphs.map((paragraph, i) => (
        <p key={i}>{paragraph}</p>
      ))}
    </SectionShell>
  );
};
